import React from 'react';
import { CardSection, Card, TypographyBody, TypographyHero, Stacker } from '@honeycomb/ui-core';
import { DealCardItem } from './DealCardItem';
import { mapCMSBackgroundColorToThemeColor } from '../utils';
export function DealCard(props) {
    const { card, withBorder = false } = props;
    const { title, description, deals, borderColor: borderColorCMS } = card;
    const borderColor = borderColorCMS ? mapCMSBackgroundColorToThemeColor(borderColorCMS) : undefined;
    return (React.createElement(Card, { h: "100%", SurfaceProps: { border: withBorder ? 1 : 0 } },
        React.createElement(CardSection, { bs: "solid", bc: borderColor, bw: "24px 0 0 0", styleId: "deal-card-section" },
            React.createElement(TypographyHero, { color: "text.heading", size: "s", mb: 2 }, title),
            React.createElement(TypographyBody, { size: "s", mb: 4 }, description),
            React.createElement(Stacker, { spacing: 3 }, deals === null || deals === void 0 ? void 0 : deals.filter((deal) => !!deal.linkUrl).map((deal) => {
                return (React.createElement(DealCardItem, { key: deal.textLine1, deal: deal, resourceStrings: card === null || card === void 0 ? void 0 : card.resourceString }));
            })))));
}
